<template>
  <div class="table-box">
    <template>
      <el-table
        ref="table"
        :data="data"
        :border="border"
        style="width: 100%"
        :show-header="showHeader"
        :highlight-current-row="highlightCurrentRow"
        @current-change="currentChange"
        empty-text="暂无数据"
        default-expand-all
        @selection-change="handleSelectionChange"
        :cell-class-name="setCellClass"
        :cell-style="setCellColor"
        :header-cell-style="setCellColor"
        :header-row-style="setHeaderRowStyle"
        @select="getSelect"
        @select-all="getSelectAll"
      >
        <slot name="header"></slot>
        <el-table-column
          v-for="(item, ind) in columns"
          :key="ind"
          :prop="item.key"
          :label="item.label"
          :width="item.width || ''"
          :min-width="item.minWidth || ''"
          :fixed="item.fixed"
          :align="item.align"
        >
          <!-- 表头渲染 -->
          <template #header>
            <!-- 如果没有头部提示 -->
            <template v-if="!item.tooTip">{{ item.label }}</template>
            <!-- 有头部提示 -->
            <template v-else>
              <!-- 如果有点击事件则优先渲染点击事件,不走默认的提示结构 -->
              <template v-if="!item.tooTip.clickFn">
                {{ item.label }}
                <el-popover
                  placement="top-start"
                  trigger="hover"
                  :content="item.tooTip.content"
                >
                  <span slot="reference">
                    <i
                      :class="[
                        item.tooTip.iconClass
                          ? item.tooTip.iconClass
                          : 'el-icon-info',
                      ]"
                    ></i>
                  </span>
                </el-popover>
              </template>
              <template v-else>
                {{ item.label }}
                <i
                  @click="item.tooTip.clickFn(item)"
                  :class="[
                    item.tooTip.iconClass
                      ? item.tooTip.iconClass
                      : 'el-icon-info',
                  ]"
                ></i>
              </template>
            </template>
          </template>

          <!-- 单元格渲染 -->
          <template #default="{ row }">
            <div
              @click="
                item.customClick && item.customClick.fn
                  ? item.customClick.fn(item, row, item.customClick.params)
                  : void 0
              "
            >
              <QS-badge
                v-if="typeof item.badge === 'function'"
                :color="item.badge(row[item.key]).color || 'red'"
                :text="item.badge(row[item.key]).text || '默认文字'"
              />
              <!-- 评分 -->
              <el-rate
                v-else-if="typeof item.score === 'function'"
                :value="item.score(row[item.key])"
                disabled
                text-color="#ff9900"
              />
              <!-- 配置显示几行走下面的逻辑 -->
              <template v-else-if="item.ellipsis">
                <el-tooltip
                  :content="publicProcessingValue(item, row)"
                  placement="top"
                >
                  <span :style="setEllipsisStyle(item.ellipsisNum)">
                    {{ publicProcessingValue(item, row) }}
                  </span>
                </el-tooltip>
              </template>

              <!-- 设置高度走这里,注意和超过隐藏不能同时存在 -->
              <template v-else-if="item.height">
                <span :style="setHeightStyle(item.height)">
                  {{ publicProcessingValue(item, row) }}
                </span>
              </template>

              <!-- 如果特殊处理都没有走,那么走正常的渲染逻辑 -->
              <template v-else>
                <span>
                  {{ publicProcessingValue(item, row) }}
                </span>
              </template>
            </div>
          </template>
        </el-table-column>

        <template v-if="!opBtns.length">
          <slot name="footer"></slot>
        </template>

        <template v-else-if="opBtns && opBtns.length">
          <el-table-column
            fixed="right"
            prop="opBtns"
            :class-name="operateBtns"
          >
            <template #header>
              <el-popover
                v-if="toolTip"
                placement="top-start"
                title
                width="200"
                trigger="hover"
                :content="toolTip"
              >
                <div slot="reference">
                  操作
                  <i class="el-icon-question"></i>
                </div>
              </el-popover>
              <span v-else>操作</span>
            </template>
            <template slot-scope="scope">
              <template>
                <!-- 渲染默认的按钮 -->
                <span
                  v-for="(item, key) in computedOpBtns(scope.row).btns"
                  :key="key"
                >
                  <el-popover
                    v-if="item.tooTip"
                    placement="top-start"
                    title
                    width="200"
                    trigger="hover"
                    :content="item.tooTip"
                  >
                    <el-button
                      type="text"
                      slot="reference"
                      @click="
                        item &&
                          item.clickFn(
                            scope.row,
                            item.params ? item.params : void 0
                          )
                      "
                      >{{ item.label }}</el-button
                    >
                  </el-popover>
                  <el-button
                    v-else
                    type="text"
                    @click="
                      item &&
                        item.clickFn(
                          scope.row,
                          item.params ? item.params : void 0
                        )
                    "
                    >{{ item.label }}</el-button
                  >
                </span>
              </template>
              <!-- 更多按钮，下拉-->
              <template v-if="computedOpBtns(scope.row).moreBtns.length">
                <el-dropdown placement="bottom" trigger="click">
                  <el-button type="text">{{ moreOpBtnsText }}</el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item
                      v-for="(item, key) in computedOpBtns(scope.row).moreBtns"
                      :key="key"
                      @click.native="
                        item &&
                          item.clickFn(
                            scope.row,
                            item.params ? item.params : void 0
                          )
                      "
                    >
                      <el-popover
                        v-if="item.tooTip"
                        placement="top-start"
                        title
                        width="200"
                        trigger="hover"
                        :content="item.tooTip"
                      >
                        <span slot="reference">{{ item.label }}</span>
                      </el-popover>
                      <span v-else>{{ item.label }}</span>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
            </template>
          </el-table-column>
        </template>
      </el-table>
      <VirtualHorizontalScroller :getTableInstance="getTableInstance" :refresh-key="data" />
      <!-- eslint-disable-next-line vue/no-mutating-props -->
      <el-pagination :currentPage.sync="pageNum"
        style="padding: 16px"
        :style="{ textAlign: paginationAlign }"
        v-if="!hiddenPage"
        background
        :hide-on-single-page="hideOnSinglePage"
        :page-size="pageSize"
        :page-sizes="pageSizes"
        :small="small"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :total="total"
      ></el-pagination>
    </template>
  </div>
</template>
<script>
import moment from 'moment'
import { VirtualHorizontalScroller } from '@qs/ui'

export default {
  name: 'tableComponent',
  components: {
    VirtualHorizontalScroller,
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    columns: {
      type: Array,
      default: () => [],
    },
    total: {
      type: Number,
      default: 0,
    },
    pageSize: {
      type: Number,
      default: 10,
    },
    pageSizes: {
      type: Array,
      default: () => [10, 20, 50, 100],
    },
    hideOnSinglePage: {
      type: Boolean,
      default: true,
    },
    border: {
      type: Boolean,
      default: false,
    },
    showHeader: {
      type: Boolean,
      default: true,
    },
    highlightCurrentRow: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    },
    pageNum: {
      type: Number,
      default: 1,
    },
    hiddenPage: {
      type: Boolean,
      default: false,
    },
    opBtnsNum: {
      type: [String, Number],
      default: 2,
    },
    opBtns: {
      type: Array,
      default: () => [],
    },
    moreOpBtnsText: {
      type: String,
      default: '···',
    },
    toolTip: {
      type: String,
      default: '',
    },
    // 表头的颜色
    headerRowStyle: {
      type: Object,
      default: () => ({
        backgroundColor: 'rgb(247, 248, 250)',
      }),
    },
    // 分页在左边还是右边
    paginationAlign: {
      type: String,
      default: 'left',
    },
    operateBtns: {
      type: String,
      default: '',
    },
  },
  computed: {
    // 计算更多展示按钮以及更多按钮数组
    computedOpBtns() {
      return function (row) {
        const _obj = {
          btns: [],
          moreBtns: [],
        }
        const _showBtns = []
        if (this.opBtns && this.opBtns.length) {
          this.opBtns.forEach((item) => {
            const computedItem = {
              label: '',
              tooTip: '',
              clickFn: item.clickFn,
              params: item.params ? item.params : undefined,
            }
            // 先处理如果Label是function的逻辑
            if ((typeof item.label).toUpperCase() === 'FUNCTION') {
              computedItem.label = item.label(row)
            } else {
              computedItem.label = item.label
            }

            if (item.tooTip) {
              computedItem.tooTip = item.tooTip
            }

            // 如果undefined则代表显示 直接push
            if (item.show === undefined) {
              _showBtns.push(computedItem)
            }

            if ((typeof item.show).toUpperCase() === 'BOOLEAN') {
              if (item.show) {
                _showBtns.push(computedItem)
              }
            }

            // 动态判断显示状态
            if ((typeof item.show).toUpperCase() === 'FUNCTION') {
              if (item.show(row, item)) {
                _showBtns.push(computedItem)
              }
            }
          })
        }
        // 如果循环后数据存在，则根据最大个数显示隐藏分为显示页面上的和更多下拉里面的
        if (_showBtns.length) {
          if (_showBtns.length - this.opBtnsNum > 0) {
            _obj.btns = _showBtns.slice(0, this.opBtnsNum)
            _obj.moreBtns = _showBtns.slice(this.opBtnsNum)
          } else {
            _obj.btns = _showBtns
          }
        }
        return _obj
      }
    },
  },
  methods: {
    getTableInstance() {
      return this.$refs.table
    },
    // 统一处理值怎么展示
    publicProcessingValue(item, row) {
      if (item.formatter) {
        return item.formatter(item, row)
      } else {
        return this.getValue(item, row)
      }
    },
    // 处理值,其中之一
    getValue(item, data) {
      // 当有时间格式优先转化时间
      if (item.timeFormat) {
        let timeVal = data[item.key]
        if (timeVal) {
          timeVal = String(timeVal)
          // 10位代表为秒
          if (timeVal.length === 10) {
            timeVal *= 1000
          }
          timeVal *= 1
          let format = 'YYYY-MM-DD HH:mm:ss'
          const timeFormatType = (typeof item.timeFormat).toLowerCase()
          if (timeFormatType === 'boolean') {
            return moment(timeVal).format(format)
          } else if (timeFormatType === 'string') {
            format = item.timeFormat
            return moment(timeVal).format(format)
          } else {
            return '--'
          }
        } else {
          return '--'
        }
      } else {
        const { key, source } = item
        const value =
          data[key] || data[key] === 0 || data[key] === false ? data[key] : ''
        const sValue =
          source &&
          (source[value] || source[value] === 0 || source[value] === false)
            ? source[value]
            : ''
        if (sValue !== '') {
          return sValue
        }
        if (value !== '') {
          return value
        }
        return '--'
      }
    },
    handleSizeChange(val) {
      this.$emit('sizeChange', val)
    },
    handleCurrentChange(val) {
      this.$emit('currentChange', val)
    },
    currentChange(val) {
      this.$emit('oneCurrentChange', val)
    },
    handleSelectionChange(val) {
      this.$emit('handleSelectionChange', val)
    },
    // 单选框
    getSelect(selection, row) {
      this.$emit('singleSelect', { selection, row })
    },
    // 全选框
    getSelectAll(selection) {
      const selectionList = selection.length > 0 ? selection : []
      this.$emit('wholeSelect', selectionList)
    },
    // 设置单元格颜色
    setCellColor({ columnIndex }) {
      const aHasIndex = []
      const aColor = []
      this.columns.forEach((item, index) => {
        if (item.color) {
          aColor.push(item.color)
          aHasIndex.push(index)
        }
      })
      const nIndexOf = aHasIndex.indexOf(columnIndex)
      if (nIndexOf > -1) {
        return `color:${aColor[nIndexOf]}`
      } else {
        return ''
      }
    },
    // 设置操作表格的样式
    setCellClass({ row, column }) {
      // 按钮列
      if (column.property === 'opBtns') {
        let _len = '' // 当前按钮的总字数
        if (this.opBtns && this.opBtns.length) {
          // 如果按钮个数大于默认设置个数 默认2
          if (this.opBtns.length - this.opBtnsNum > 0) {
            this.opBtns.slice(0, this.opBtnsNum).forEach((item) => {
              if ((typeof item.label).toUpperCase() === 'FUNCTION') {
                _len += item.label(row)
              } else {
                _len += item.label
              }
            })
            // 更多字符的默认文案 ···
            _len += this.moreOpBtnsText
          } else {
            this.opBtns.forEach((item) => {
              if ((typeof item.label).toUpperCase() === 'FUNCTION') {
                _len += item.label(row)
              } else {
                _len += item.label
              }
            })
          }
          column.width = _len.length * 18 + 20
          return 'op-cell'
        }
      }
    },
    // 设置几行显示省略号样式
    setEllipsisStyle(num = 2) {
      return {
        display: ['-webkit-box', 'box'],
        lineClamp: num,
        boxOrient: 'vertical',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
      }
    },
    // 设置单元格的高度
    setHeightStyle(height) {
      const type = (typeof height).toLowerCase()
      if (type === 'number') {
        height += 'px'
      }
      return {
        display: 'block',
        height,
      }
    },
    // 设置表头样式,表头背景色就是在这里设置的
    setHeaderRowStyle() {
      if (
        this.headerRowStyle.backgroundColor ||
        this.headerRowStyle.background
      ) {
        return this.headerRowStyle
      } else {
        return {
          backgroundColor: 'rgb(247, 248, 250)',
          ...this.headerRowStyle,
        }
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.table-box ::v-deep .el-table__body-wrapper::-webkit-scrollbar {
  height: 0 !important;
  display: none !important;
}
.table-box ::v-deep .el-table__body-wrapper {
  scrollbar-width: none;
  -ms-overflow-style: none;
}
.table-box ::v-deep .op-cell .cell > * {
  margin-left: 10px;
  &:first-child {
    margin-left: 0 !important;
  }
}
.table-box ::v-deep .el-table__body .td-canclick {
  color: #0059dc;
  cursor: pointer;
  span {
    color: #0059dc;
    cursor: pointer;
  }
}
</style>
